import { CONTACT_ANALYTICS, CONTACTS_INNER_ANALYTICS } from 'constants/types';
import { IContactAnalyticsItem, IContactSorting, IDashboardData } from '../interfaces';

// Contacts Analytics
const initialContactAnalyticsState = {
  tab: '',
  delivered: Array<IContactAnalyticsItem>(),
  deliveredLoading: false,
  deliveredPage: 0,
  deliveredSortBy: 'none',
  deliveredSortType: 'none',
  total_delivered: 0,
  bounced: Array<IContactAnalyticsItem>(),
  bouncedLoading: false,
  bouncedPage: 0,
  total_bounced: 0,
  unsubscribed: Array<IContactAnalyticsItem>(),
  unsubscribedLoading: false,
  unsubscribedPage: 0,
  total_unsubscribed: 0,
  selectedPerson: {} as IContactAnalyticsItem,
  contactsByFilter: '',
  searchContact: '',
  redirectUrl: '',
  filterReset: false,
  searchReset: false,
  countPage: 0,
  bounceFilter: '',
  isBounceFilterAppliedFirstTime: false,
  deliveredSorting: { accessor: '', sortDirection: 'none' } as IContactSorting,
  bouncedSorting: { accessor: '', sortDirection: 'none' } as IContactSorting,
  unsubscribedSorting: { accessor: '', sortDirection: 'none' } as IContactSorting,
};

export const analyticsContactReducer = (state: any = initialContactAnalyticsState, action: any) => {
  const newState = { ...state };
  switch (action.type) {
    case CONTACT_ANALYTICS.FILTER_RESET:
      newState.filterReset = action.payload;
      return newState;
    case CONTACT_ANALYTICS.SEARCH_RESET:
      newState.searchReset = action.payload;
      return newState;

    //Selected Contact
    case CONTACT_ANALYTICS.SET_SORT_PROPS:
      newState.deliveredSortBy = action.payload.sortBy;
      newState.deliveredSortType = action.payload.sortType;
      return newState;
    case CONTACT_ANALYTICS.SET_CONTACTS_BY_FILTER:
      newState.contactsByFilter = action.payload;
      return newState;

    case CONTACT_ANALYTICS.SELECTED_PERSON:
      newState.selectedPerson = action.payload.selectedPerson;
      return newState;

    case CONTACT_ANALYTICS.SELECTED_PERSON_RESET:
      newState.selectedPerson = {};
      return newState;

    //Delivered tab
    case CONTACT_ANALYTICS.DELIVERED_LOAD:
      newState.deliveredLoading = true;
      return newState;
    case CONTACT_ANALYTICS.DELIVERED_SUCCESS:
      newState.deliveredLoading = false;
      if (action.payload.offset === 0) {
        newState.total_delivered = action.payload.total_delivered !== undefined ? action.payload.total_delivered : 0;
        newState.delivered = action.payload.delivered;
      } else {
        newState.delivered = [...newState.delivered, ...action.payload.delivered];
      }
      newState.deliveredPage = newState.deliveredPage + 1;
      return newState;
    case CONTACT_ANALYTICS.DELIVERED_RESET:
      newState.delivered = [];
      newState.total_delivered = 0;
      newState.deliveredPage = 0;
      return newState;
    case CONTACT_ANALYTICS.DELIVERED_FAIL:
      newState.deliveredLoading = false;
      return newState;

    //Bounced Tab
    case CONTACT_ANALYTICS.BOUNCED_LOAD:
      newState.bouncedLoading = true;
      return newState;
    case CONTACT_ANALYTICS.BOUNCED_SUCCESS:
      newState.bouncedLoading = false;
      if (action.payload.offset === 0) {
        newState.bounced = action.payload.bounced;
        newState.total_bounced = action.payload.total_bounced !== undefined ? action.payload.total_bounced : 0;
      } else {
        newState.bounced = [...newState.bounced, ...action.payload.bounced];
      }
      newState.bouncedPage = newState.bouncedPage + 1;
      return newState;
    case CONTACT_ANALYTICS.BOUNCED_RESET:
      newState.bounced = [];
      newState.total_bounced = 0;
      newState.bouncedPage = 0;
      return newState;
    case CONTACT_ANALYTICS.BOUNCED_FAIL:
      newState.bouncedLoading = false;
      return newState;

    //Unsubscribed Tab
    case CONTACT_ANALYTICS.UNSUBSCRIBED_LOAD:
      newState.unsubscribedLoading = true;
      return newState;
    case CONTACT_ANALYTICS.UNSUBSCRIBED_SUCCESS:
      newState.unsubscribedLoading = false;
      if (action.payload.offset === 0) {
        newState.total_unsubscribed = action.payload.total_unsubscribed !== undefined ? action.payload.total_unsubscribed : 0;
        newState.unsubscribed = action.payload.unsubscribed;
      } else {
        newState.unsubscribed = [...newState.unsubscribed, ...action.payload.unsubscribed];
      }
      newState.unsubscribedPage = newState.unsubscribedPage + 1;
      return newState;
    case CONTACT_ANALYTICS.UNSUBSCRIBED_RESET:
      newState.unsubscribed = [];
      newState.total_unsubscribed = 0;
      newState.unsubscribedPage = 0;
      return newState;
    case CONTACT_ANALYTICS.UNSUBSCRIBED_FAIL:
      newState.unsubscribedLoading = false;
      return newState;

    case CONTACT_ANALYTICS.SET_SEARCH_TEST:
      newState.searchContact = action.payload.search;
      return newState;

    case CONTACT_ANALYTICS.SET_TAB:
      newState.tab = action.payload.tab;
      return newState;

    case CONTACT_ANALYTICS.SET_REDIRECT_URL:
      newState.redirectUrl = action.payload.redirectUrl;
      return newState;
    case CONTACT_ANALYTICS.RESET_REDIRECT_URL:
      newState.redirectUrl = '';
      return newState;

    case CONTACT_ANALYTICS.RESET_ALL:
      newState.unsubscribed = [];
      newState.total_unsubscribed = 0;
      newState.unsubscribedPage = 0;
      newState.bounced = [];
      newState.total_bounced = 0;
      newState.bouncedPage = 0;
      newState.delivered = [];
      newState.total_delivered = 0;
      newState.deliveredPage = 0;
      newState.deliveredSorting = { accessor: '', sortDirection: 'none' };
      newState.bouncedSorting = { accessor: '', sortDirection: 'none' };
      newState.unsibscribedSorting = { accessor: '', sortDirection: 'none' };
      return newState;

    case CONTACT_ANALYTICS.SET_UNSUB_BOUNCE_TOTAL_COUNT:
      newState.total_unsubscribed = action.total_unsubscribed;
      newState.total_bounced = action.total_bounced;
      newState.total_delivered = action.total_delivered;
      newState.countPage = 1;
      return newState;

    case CONTACT_ANALYTICS.SET_UNSUB_BOUNCE_TOTAL_COUNT_LOADING:
      newState.countPage = action.payload;
      return newState;

    case CONTACT_ANALYTICS.SET_BOUNCE_FILTER:
      newState.bounceFilter = action.payload;
      return newState;

    case CONTACT_ANALYTICS.SET_BOUNCE_FILTER_FIRST_TIME:
      newState.isBounceFilterAppliedFirstTime = action.payload;
      return newState;

    case CONTACT_ANALYTICS.SET_DELIVERED_CONTACTS_SORTING:
      newState.deliveredSorting.accessor = action.payload.accessor;
      newState.deliveredSorting.sortDirection = action.payload.sortDirection;
      return newState;

    case CONTACT_ANALYTICS.SET_BOUNCED_CONTACTS_SORTING:
      newState.bouncedSorting.accessor = action.payload.accessor;
      newState.bouncedSorting.sortDirection = action.payload.sortDirection;
      return newState;

    case CONTACT_ANALYTICS.SET_UNSUBSCRIBED_CONTACTS_SORTING:
      newState.unsubscribedSorting.accessor = action.payload.accessor;
      newState.unsubscribedSorting.sortDirection = action.payload.sortDirection;
      return newState;

    default:
      return newState;
  }
};

// Contacts Inner Details
const initialContactsInnerState = {
  dashboard: {} as Array<IDashboardData>,
  dashboardLoading: false,
  content: [],
  contentPage: 0,
  contentLoading: false,
};

export const contactInnerDetailsReducer = (state: any = initialContactsInnerState, action: any) => {
  const newState = { ...state };
  switch (action.type) {
    //Dashboard tab
    case CONTACTS_INNER_ANALYTICS.DASHBOARD_LOAD:
      newState.dashboardLoading = true;
      return newState;
    case CONTACTS_INNER_ANALYTICS.CAMPAINGS_LOAD:
      newState.dashboard.campaingsLoading = true;
      return newState;
    case CONTACTS_INNER_ANALYTICS.DASHBOARD_SUCCESS:
      newState.dashboardLoading = false;
      newState.campaingsLoading = false;
      //newState.dashboard = action.payload.dashboard;
      let offset = action.payload.offset;
      newState.dashboard.subscribed_campaigns = newState.dashboard.subscribed_campaigns
        ? [...newState.dashboard.subscribed_campaigns, ...action.payload.dashboard.subscribed_campaigns]
        : action.payload.dashboard.subscribed_campaigns;
      if (offset === 0) {
        newState.dashboard.total_subscribed_campaigns = action.payload.dashboard.total_subscribed_campaigns;
        newState.dashboard.contact_details = action.payload.dashboard.contact_details;
        newState.dashboard.contact_intent_data = action.payload.dashboard.contact_intent_data;
      }
      newState.dashboard.campaignsPage = 0;
      newState.dashboard.campaingsLoading = false;
      return newState;
    case CONTACTS_INNER_ANALYTICS.DASHBOARD_FAIL:
      newState.dashboardLoading = false;
      newState.campaingsLoading = false;
      return newState;

    case CONTACTS_INNER_ANALYTICS.DASHBOARD_RESET:
      newState.dashboardLoading = false;
      newState.campaingsLoading = false;
      newState.dashboard = {};
      return newState;

    //Content engagement tab
    case CONTACTS_INNER_ANALYTICS.CONTENT_LOAD:
      newState.contentLoading = true;
      return newState;
    case CONTACTS_INNER_ANALYTICS.CONTENT_SUCCESS:
      newState.contentLoading = false;
      if (newState.contentPage === 0) {
        newState.content = action.payload.content;
      } else {
        newState.content = [...newState.content, ...action.payload.content];
      }
      if (action.payload.content.length > 0) {
        newState.contentPage = state.contentPage + 1;
      }
      return newState;
    case CONTACTS_INNER_ANALYTICS.CONTENT_FAIL:
      newState.contentLoading = false;
      return newState;
    case CONTACTS_INNER_ANALYTICS.CONTENT_RESET:
      newState.contentPage = 0;
      newState.content = [];
      return newState;
    case CONTACTS_INNER_ANALYTICS.RESET_CONTACT_DETAILS:
      newState.dashboardLoading = false;
      newState.dashboard = {};
      newState.content = [];
      newState.contentPage = 0;
      newState.contentLoading = 0;
      return newState;
    default:
      return newState;
  }
};
